import type { CalculatorMetadata, Quant } from '../types'

/**
 * Короткая подпись единицы для строк таблицы. Бэк отдаёт только полные
 * («Граммы»), а в строке рядом с числом нужна короткая.
 */
const SHORT_LABEL: Record<Quant, string> = {
  g: 'г',
  ml: 'мл',
  pcs: 'шт',
}

export const quantShort = (quant: Quant): string => SHORT_LABEL[quant] ?? quant

/** Какие размеры заполнены у формы этого типа. Набор задаёт бэк. */
export const formDimensions = (
  metadata: CalculatorMetadata | undefined,
  formType: string
) => metadata?.forms.find(form => form.form_type === formType)?.dimensions ?? []

export const formLabel = (
  metadata: CalculatorMetadata | undefined,
  formType: string
) =>
  metadata?.forms.find(form => form.form_type === formType)?.label ?? formType
